export default {
  route: {
    dashboard: 'Dashboard',
    orders: 'Orders',
    brands: 'Brands',
    invoices: 'Invoices',
    prepaidAccounts: 'Prepaid accounts',
    prepaidAccountView: 'Prepaid account',
    brandView: 'Brand view',
    profile: 'Profile',
    purchase: 'Order taking',
    fileMapper: 'File Mapper',
    stocks: 'Stocks',
    volumeByBuyers: 'Volume per buyer',
    ratesManagement: 'Offers management',
    notifications: 'Notifications',
    MultiChoiceCards: 'Multi-choice cards',
    operation: 'Operations',
    purchaseInfos: 'Purchase infos',
    buyersManagement: 'Buyers management',
    buyersManagementView: 'Buyer management',
    customers: 'Customers',
    cards: 'eBons traceability',
    nativeAppUsers: 'Native app',
    enrollment: 'Enrollment',
    register: 'Enrollment',
    newDotationOrder: 'New dotation order',
    dotationOrdersList: 'Orders and deposits list',
    newAcompte: 'Make a deposit',
    cultureSubsidy: 'Culture subsidy',
    cultureSubsidyAdmin: 'Culture subsidy',
  },
  navbar: {
    logOut: 'Disconnect from market',
    logOutWalleo: 'Disconnect from market and walleo account',
    dashboard: 'Dashboard',
    profile: 'Profile'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Email',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
    any: 'any',
    emailError: 'Please enter the correct email address',
    passwordLengthError: 'The password can not be less than 6 digits',
    wrongCredentialsError: 'Wrong email or password',
    forgotPassword: 'Forgot password'
  },
  profile: {
    cardTitle: 'My profile',
    tabs: {
      account: {
        title: 'Account',
        personalInfo: 'Personal informations',
        firstname: 'First name',
        lastname: 'Last name',
        email: 'Email',
        password: 'Password',
        changePassword: 'Change password',
      }
    }
  },
  dashboard: {
    selectPeriod: "Select a period",
    periods: {
      lastMonth: 'Last month',
      today: "Today",
      week: 'This week',
      month: 'This month',
      year: 'This year'
    },
    stats: {
      stat1: 'API orders / Bulk orders',
      stat2: 'Amount in facial value',
      stat3: 'Commission',
    },
    volumesBarChart: {
      title: 'Volumes',
      options: {
        buy: "of purchase",
        sell: 'of sale'
      },
      volumesBy: {
        total: 'Total per',
        giftCards: 'brand',
        buyers: 'buyer'
      }
    },
    leaderboardChart: {
      title: 'Top',
      options: {
        giftCards: 'brands',
        buyers: 'buyers'
      },
    },
    table: {
      ref: 'Reference',
      amount: 'Amount',
      faceValue: 'Facial value',
      commissionRate: 'Commission rate excl.',
      commissionHT: 'Commission excl.',
      commissionTTC: 'Commission incl. VAT',
      date: 'Date',
    },
    hello: 'Hi',
    connectedAs: 'Connected as',
    activityBlock: {
      title: 'Activity',
      subtitle: 'See each column for more details',
      turnover: 'turnover',
      ordersNotProcessed: 'orders to be processed',
      ordersNotDelivered: 'orders to be delivered',
      ordersUnpaid: 'unpaid orders'
    },
    ordersBlock: {
      title: 'Orders',
      subtitle: 'Orders requiring your intervention',
      noPaymentRecorded: 'No payment recorded',
      orderNotProceed: 'Order has not been processed'
    },
    prepaidAccountBlock: {
      prepaidAccount: 'available balance',
      creditWaiting: 'pending credit note'
    }
  },
  orders: {
    header: {
      title: 'Order tracking',
      subtitle: 'Find your orders on this interface',
      btnSwitchToBuyer: 'View my buyer orders',
      btnSwitchToSeller: 'View my seller orders'
    },
    splittedTable: {
      btnSplit: 'Split mode',
      table1: 'Buyer orders',
      table2: 'Seller orders',
    },
    buyer: {
      filters: {
        filterBtn: 'Refine orders by',
        title: 'Refine',
        subtitle: 'Get better results using our smart filters',
        orderNumber: 'Order number',
        refCustomer: 'External transaction reference',
        timeInterval: 'Time range',
        startDate: 'Start date',
        to: 'to',
        endDate: 'End date',
        status: 'Order status',
        paymentStatus: 'Payment status',
        deliveryStatus: 'Delivery status',
        gitfCard: 'Brands',
        buyers: 'Buyers',
        buyersInfo: 'Applicable only on buyers order view',
        applyFilters: 'Apply and see'
      },
      codes: {
        download: 'Download raw codes',
        multipleFiles: 'files of codes to be downloaded'
      },
      card: {
        ref: 'Ref.',
        buyer: 'Buyer',
        faceValue: 'Face value',
        activeFrom: 'Active from',
        orderPaid: 'Paid',
        orderPaidOn: 'Paid on',
        status: {
          text: 'Status',
          refunded: 'Refunded',
          yes: 'Yes',
          partial: 'Partial',
          no: 'No',
          inProgress: 'In progress'
        },
        paymentDeadline: 'Payment due date',
        btnSeeMoreDetails: 'See more details',
        exceeding: 'exceeding of',
        orderDelivered: 'Delivered',
        orderDeliveredOn: 'Delivered on',
        detailOrder: 'Please detail your order',
        confirmOrder: 'Confirm order ?',
        proceed: 'Go',
        notNow: 'Not now',
        processOrder: 'Process my order',
        waitingDetails: 'Waiting for detail',
        btnPaymentWithBalance: 'Pay',
        paymentWithBalanceOptions: {
          opt1: 'Confirm',
          opt2: 'Cancel'
        },
        orderInfo: {
          phrasing1: 'To facilitate the identification of your future payment of',
          phrasing2: ', thank you for using',
          phrasing3: 'as bank transfer reference.'
        },
        menu: {
          details: 'Details',
          edit: 'Edit',
          delete: 'Delete',
          resume: 'Resume',
          suspend: 'Suspend'
        },
        deleteButtonConfirm: {
          title: 'Are you sure you want to delete this order ?',
          opt1: 'Confirm',
          opt2: 'Cancel'
        },
      }
    },
    seller: {
      header: {
        title: 'Orders monitoring',
        subtitle: 'Keep an eye on your deliveries'
      },
      filters: {
        filterBtn: 'Refine orders by',
        title: 'Refine',
        subtitle: 'Get better results using our smart filters',
        orderNumber: 'Order number',
        timeInterval: 'Time range',
        startDate: 'Start date',
        to: 'to',
        endDate: 'End date',
        orderStatus: 'Delivery status',
        applyFilters: 'Apply and see'
      },
      status: {
        complete: 'Complete delivery',
        partial: 'Partial delivery',
        waiting: 'Pending delivery',
        errors: {
          title: 'Delivery failure',
          details: 'No errors found | {count} Error found | {count} Errors found'
        }
      },
      card: {
        faceValue: 'Face value',
        progressBarTooltip: 'You have delivered a total of {amount} code(s) out of {total} code(s)',
        cardDistributions: 'Delivery detail',
        cardDistributionsDetails: 'card(s) of an amount equal to',
        cardDistributionsEmpty: 'Not specified',
        deliverCodes: 'Deliver the codes'
      },
      codesDialog: {
        title: 'Upload codes file',
        subtitle: 'Order #',
        step1: {
          note: 'Get sure your codes file does not contain any errors and that your File Mapper is correctly set up. The configuration of expiry date is at next step.'
        },
        step2: {
          codeActivationDate: 'Codes activation date',
          placeholderActivationDate: 'Indicate date and time of codes activation',
          note: 'Once activation date is filled, your file will be ready to be processed.',
          warning: 'Warning, after clicking on "Confirm delivery" codes are fully delivered',
          cancelBtn: 'Cancel',
          confirmBtn: 'Confirm delivery',
          processingBtn: 'Processing...'
        },
        step3: {
          deliveryErrors: {
            title: 'Delivery failed',
            subtitle: 'File uploaded contains errors. Check that the File Mapper used is correct. Find errors below.',
            backToOrderBtn: 'Back to orders',
            newDeliveryBtn: 'New delivery'
          },
          deliverySuccess: {
            title: 'The order #{number} has been delivered',
            codeActivationDate: 'Codes will be activated on:',
            backToOrderBtn: 'Back to orders'
          }
        },
        deliveryCodesDetails: {
          title: 'View order detail'
        },
        manageFileMapper: {
          title: 'Manage my File Mappers',
          byDefaultBtn: 'Set by default',
          notification: {
            success: {
              title: 'File Mapper updated',
              subtitle: 'Default File Mapper has been updated'
            },
            error: {
              title: 'File Mapper error',
              subtitle: 'Impossible to change default File Mapper'
            }
          }
        },
        handleDeliveryErrors: {
          title: 'A total of {amount} errors have been found upon delivery',
          subtitle: '- Please correct errors before making new delivery',
          moreDetailsBtn: '- View more details',
          errorLine: 'Error line'
        }
      },
      rules: {
        activationDateRequired: 'Activation date required',
        codeFileRequired: 'Code file required'
      }
    },
    wholesaler: {
      btnWholesalerOrders: 'Seller orders',
      btnSeeBuyersOrders: 'Buyer orders',
      btnLaunchDelivery: 'Launch delivery',
      seller: 'Seller',
    },
    notification: {
      delete: {
        title: 'Success',
        message: 'Delete Successfully'
      },
      resumeSuccess: {
        title: 'Success',
        message: 'The order has been put into processing'
      },
      resumeError: {
        title: 'Error',
        message: 'The order could not be processed'
      },
      suspendSuccess: {
        title: 'Success',
        message: 'The order has been suspended'
      },
      suspendError: {
        title: 'Error',
        message: 'The order could not be suspended'
      },
      deliverySuccess: {
        title: 'Delivery order',
        message: 'The delivery of the order is launched'
      },
      deliveryError: {
        title: 'Unable to deliver the order',
        message: 'The delivery could not be started'
      },
      downloadError: {
        title: 'Download failed',
        message: 'An error occurred while downloading'
      }
    },
    noMore: 'You have come to the end',
    noResults: 'No result',
    btnMore: 'Load more orders'
  },
  invoices: {
    header: {
      title: 'My invoices',
      subtitle: 'Find your invoices issued for each order',
      type: {
        seeInvoicesOfBtn: 'View invoices',
        buyers: 'buyers',
        sellers: 'sellers'
      },
      filters: {
        filterBtn: 'Filter my invoices',
        title: 'Filters',
        subtitle: 'Get better results by using our smart filters',
        paymentMode: 'Payment mode',
        invoicePer: 'Invoice per',
        invoicePerOrder: 'Per order',
        invoicePerMonth: 'Monthly',
        paymentModePrepaid: 'Prepaid',
        paymentModeDiffered: 'Delayed',
        invoiceNumber: 'Invoice number',
        timeInterval: 'Time range',
        startDate: 'Start date',
        to: 'to',
        endDate: 'End date',
        paymentStatus: 'Payment status',
        orderNumber: 'Order number',
        sellers: 'Sellers',
        buyers: 'Buyers',
        applyFilters: 'Apply and see'
      },
      extractInvoicesBtn: 'Extract invoices'
    },
    table: {
      col2: 'Date',
      col3: 'Invoice No.',
      col4: 'Mode',
      col5: 'Amount',
      col6: 'Status',
      seeMoreBtn: 'See more invoices'
    },
    asidePanel: {
      title: 'Invoice details',
      closeBtn: 'Close',
      multiBrands: 'Multi-brands',
      overpaymentOf: 'Overpayment of',
      underpaidOf: 'Underpayment of',
      type: 'Invoice type',
      standard: 'Standard',
      commission: 'Commission',
      issuedOn: 'Issued on',
      dueDate: 'Due date',
      payment: 'Payment',
      amountToBePaid: 'Total amount',
      balance: 'Balance due',
      number: 'N°',
      commentComponent: {
        comment: 'Comment',
        placeholder: 'Type your comment here...',
        notSpecified: 'No comment',
        btnAdd: 'Add a comment',
        btnEdit: 'Edit',
        btnSave: 'Save',
        btnCancel: 'Cancel',
        notification: {
          success: {
            title: 'Success',
            subtitle: 'Comment updated'
          },
          error: {
            title: 'Error',
            subtitle: 'An error occured'
          }
        }
      },
      notSpecified: 'Not specified',
      seeAndDownloadBtn: 'See and download my invoice',
      sendInvoiceBtn: 'Send my invoice',
      modifyInvoiceBtn: 'Edit my invoice',
      popoverValue: {
        number: {
          title: 'Edit invoice number',
          placeholder: 'Enter the invoice number',
        },
        customNumber: {
          title: 'Add a reference',
          titleEdit: 'Edit reference',
          placeholder: 'Enter the reference',
          btn: 'Add a reference',
        },
        error: {
          number: 'Invoice number is required',
          customNumber: 'Reference is required',
        }
      },
      paymentStatusResultSubtitles: {
        paid: 'No action required',
        unpaid: 'Please proceed to payment',
        late: 'You have a late payment'
      },
      relatedOrders: {
        title: 'Related Orders',
        ref: 'Ref.',
        notSpecified: 'No documented',
        seeMoreBtn: 'See more orders',
        inputOrderNumber: 'Order number'
      },
      relatedBankTransfer: {
        title: 'Related bank transfer(s)',
        total: 'Total transfer',
        empty: 'No bank transfer issued'
      },
      seePaymentProof: 'Check proof of payment'
    },
    uploadInvoiceDialog: {
      title: 'Download your invoice',
      invoiceNumber: 'Invoice number',
      invoice: 'Invoice',
      mandatoryFieldPDF: '(PDF only)',
      cancelBtn: 'Cancel',
      uploadInvoiceBtn: 'Download my invoice',
      numberIsRequired: 'Invoice number required',
      fileIsRequired: 'PDF file required',
      notification: {
        success: {
          title: 'Invoice downloaded',
          message: 'The invoice has been successfully downloaded'
        },
        error: {
          title: 'An error occured',
          message: 'The invoice could not be downloaded'
        }
      }
    }
  },
  extractInvoicesDialog: {
    title: 'Extract invoices',
    inputMonths: 'Dates of invoices to extract',
    to: 'to',
    startDate: 'Start date',
    endDate: 'End date',
    cancelBtn: 'Abort',
    extractBtn: 'Download the extraction in csv',
    notification: {
      error: {
        title: 'Error',
      }
    }
  },
  prepaidAccount: {
    header: {
      title: 'Overview of prepaid accounts',
      subtitle: 'Find your customers prepaid accounts on this page',
      title2: 'Prepaid account',
      subtitle2: 'Find the movements of your customers prepaid account on this page',
      stats: {
        stats1: 'available balance'
      },
      filters: {
        filterBtn: 'More filters',
        title: 'Filters',
        subtitle: 'Get better results using our smart filters',
        orderNumber: 'Order number',
        timeInterval: 'Time range',
        startDate: 'Start date',
        to: 'to',
        endDate: 'End date',
        giftCard: 'Brands',
        seller: 'Seller',
        reference: 'Reference',
        reason: 'Reason',

        extraction: {
          title: 'Monthly reports',
          subtitle: 'Download your reports in csv format',
          btn: 'Download',
          notification: {
            error: {
              title: 'Error while extracting',
              message: 'Enter a period'
            }
          }
        },
        applyFilters: 'Apply and see',
        setGlobalViewBtn: 'Overview',
        setSellersViewBtn: 'View by seller',
      },
      alert: {
        title: 'balance alert',
        dialog: {
          title: 'Add available balance alert',
          subtitle: 'An email will be sent to you once the amount entered has been exceeded',
          rules: {
            required: 'Amount is required'
          }
        },
        notification: {
          success: {
            title: 'Succès',
            subtitle: 'Alerte de solde disponible ajoutée avec succès'
          },
          error: {
            title: 'Erreur',
            subtitle: 'L\'alerte de solde n\'a pas pu être ajouté'
          },
        }
      }
    },
    extractDialog: {
      title: 'Monthly reports',
      alert: {
        title: 'Information',
        subtitle: 'Filters are not applied when downloading the report'
      },
      inputMonths: 'Month of report to download',
      currentMonth: 'Current month',
      cancelBtn: 'Cancel',
      extractBtn: 'Download the report in csv',
    },
    table: {
      ref: 'Ref.',
      buyer: 'Buyer',
      requestId: 'Request ID',
      giftCard: 'Brand',
      bankTransfer: 'Bank transfer',
      amount: 'Amount',
      faceValue: 'Facial value',
      commissionRate: 'Commission rate excl.',
      commissionHT: 'Commission excl.',
      commissionTTC: 'Commission incl. VAT',
      date: 'Date',
      btnMore: 'See more moves',
      btnMoreBalance: 'See more balance',
      paginationOn: 'on',
      noResult: 'No result'
    },
    processing: 'Processing'
  },
  stock: {
    header: {
      title: 'My stock of e-gift card',
      subtitle: 'Find the stocks of each of your brands',
      stats: {
        stats1: 'order(s) to fulfill'
      },
      filters: {
        filterBtn: 'Filter/Sort the stock',
        title: 'Filters',
        subtitle: 'Get better results using our smart filters',
        giftCard: 'Brands',
        sortStock: 'Sort the stock',
        sortStockSubtitle: 'Sort your stock to prevent stock-outs',
        sortBy: 'Sorted by',
        options: {
          name: 'Name of the retail brand',
          delivery: 'Priority pruchase'
        },
        applyFilters: 'Apply and see'
      }
    },
    card: {
      faceValueStock: 'Stock in face value',
      modeTooltip: 'Supply method',
      orderToFulfill: 'Order(s) to fulfill',
      amountDetails: 'Detail of the amount',
      equalAmount: '{quantity} card(s) for an amount equal to {amount} | {quantity} card(s) for an amount equal to {amount} | {quantity} card(s) for an amount equal to {amount}',
      subtotal: 'Subtotal',
      createOrderBtn: 'Place an order',
      editOrderBtn: 'Edit the order',
      faceValue: 'Face value',
      toOrder: 'To order',
      availableStock: 'Available stock',
      available: 'Available',
      sharedStock: 'Shared stock',
      shared: 'Shared',
      reservedStock: 'Reserved stock',
      reserved: 'Reserved'
    },
    noMore: 'You have come to the end',
    noResults: 'No result',
    btnMore: 'Load more brands',
    notification: {
      success: {
        title: 'Order created',
        message: '#{number} has been placed in your orders'
      }
    }
  },
  volumeByBuyers: {
    header: {
      title: 'Purchase volume',
      subtitle: 'View your purchase volume',
      filters: {
        filterBtn: 'Filter buyers',
        title: 'Filters',
        subtitle: 'Get better results using our smart filters',
        findBuyer: 'Find a buyer',
        selectYear: 'Select a year',
        applyFilters: 'Apply and see'
      }
    },
    table: {
      col1: 'Buyer',
      col2: 'Applied rate',
      col3: 'Total volume',
      col4: 'Volume', // Ex: Volume (2022)
      col5: 'History (overview)',
      empty: 'No buyer'
    }
  },
  fileMapper: {
    title: 'Create a new File Mapper',
    uploadBlock: {
      title: 'Drag and drop your file',
      or: 'Or',
      title2: 'click hear to open file explorer',
      title3: '(Automatic detection of your file\'s headers)',
      errorMultipleFiles: 'Only support uploading one file!',
      errorUnreadbleFile: 'File not supported'
    },
    manualBtn: 'Add manually ',
    subtitleManual: 'Add manually the name of columns headers while assigning them to corresponding variables.',
    table: {
      col1: 'Generated on',
      col2: 'Default',
      col3: 'Cents'
    },
    fileMapperDialog: {
      new: 'File Mapper creation',
      edit: 'Update File Mapper',
      info: {
        title: 'Information',
        content: 'Code and Amount variables are mandatory to generate the File Mapper. Other available variables are optional.'
      },
      requiered: 'Required',
      selectHeader: 'Select an header',
      headerName: 'Header name',
      columnNumber: 'Column number',
      optional: 'Opt.', // 3 lettres MAX
      code: 'Code',
      amount: 'Amount',
      pinCode: 'PIN Code',
      expiration: 'Expiry',
      configuration: {
        fileFormat: 'File format',
        fileFormatLabel: 'Does your file has headers ?',
        additionalSetups: 'Additional settings',
        separator: 'Column separating character',
        separatorLabel: 'Indicate the separating character of each column of your file',
        byDefault: 'By default:',
        comma: 'comma',
        dateFormat: 'Date format',
        dateFormatLabel: 'Fill in the expiry date format',
        year: 'Year',
        month: 'Month',
        day: 'Day',
        exemple: 'Example',
        switchByDefault: 'Default File Mapper',
        switchAmountInCentimes: 'Amount expressed in cents'
      },
      cancelBtn: 'Cancel',
      editFileMapper: 'Update',
      createFileMapper: 'Create a File Mapper',
      errors: {
        codeRequiered: 'Code variable must be assigned',
        amountRequiered: 'Amount variable must be assigned'
      },
      notification: {
        success: {
          title: 'File Mapper created',
          subtitle: 'File Mapper successfully created'
        },
        update: {
          title: 'File Mapper updated',
          subtitle: 'File Mapper successfully updated'
        },
        error: {
          title: '',
          subtitle: ''
        }
      }
    }
  },
  brands: {
    header: {
      title: 'Brands',
      subtitle: 'Find information about your brands',
      productID: 'Product ID',
      filters: {
        giftCard: 'Find a brand'
      },
    },
    card: {
      copyID: 'Copy ID',
      copyProductID: 'Copier product ID',
      details: 'Details'
    },
    table: {
      noMore: 'You have come to the end',
      noResults: 'No result',
      btnMore: 'Load more brands',
      paginationOn: 'on'
    },
    view: {
      generalInformations: 'General informations',
      description: 'Description',
      descriptionOnWallet: 'This description will be displayed on the wallet brand information sheet',
      notSpecified: 'Not specified',
      baseline: 'Baseline / Brand signature',
      useForPDF: 'Use for PDF generation',
      use: 'Use',
      howToUseEbon: 'How to use an e-gift card',
      useEbonOn: 'Use e-gift card',
      online: '(Online)',
      offline: '(Offline)',
      termsOfUse: 'Terms of use',
      characteristic: 'Characteristic',
      cumulativeOnline: {
        title: 'Cumulative online',
        opt1: 'Yes',
        opt2: 'until',
        opt3: 'Unlimited',
        opt4: 'No'
      },
      cumulativeOffline: {
        title: 'Cumulative in store',
        opt1: 'Yes',
        opt2: 'until',
        opt3: 'Unlimited',
        opt4: 'No'
      },
      usable: {
        title: 'Use',
        opt1: 'Online / Store',
        opt2: 'Online only',
        opt3: 'Only in store'
      },
      splittable: {
        title: 'Splittable',
        opt1: 'Yes',
        opt2: 'No'
      },
      validity: {
        title: 'Validity',
        opt1: 'Unlimited'
      },
      pinCode: {
        title: 'Code PIN',
        opt1: 'Yes',
        opt2: 'No'
      },
      pinCodeConcatenation: {
        title: 'PIN code concatenation',
        opt1: 'Yes',
        opt2: 'No'
      },
      api: {
        title: 'API',
        opt1: 'Yes',
        opt2: 'No (Stock mode)'
      },
      barcodeSymbology: 'Barcode type',
      others: 'Others',
      onlineUrl: 'Online store URL',
      linkToAccess: 'Link to access the brand\'s online store',
      partnerStore: 'Partner shops',
      partnerStoreList: 'List of partner shops for the use of e-gift cards',
      sku: {
        title: 'Related Sku(s)',
        table: {
          col1: 'Value Type',
          col2: 'Value',
          col3: 'Free value (minimum)',
          col4: 'Free value (maximum)'
        },
        options: {
          yes: 'Free value',
          no: 'Fixed'
        }
      },
      images: {
        title: 'Image bank',
        squareLogo: 'Square logo',
        squareLogoDetails: 'Original size : 250x250px',
        bannerImage: 'Banner logo',
        bannerImageDetails: 'Original size : 550x250px',
        cardImage: 'Card image',
        cardImageDetails: `No default size (16/9)`,
        downloadBtn: 'Download'
      },
      period: {
        year: '{year} year | {year} years | {year} years',
        month: '{month} month | {month} months | {month} months',
        separator: 'and'
      }
    }
  },
  purchaseInfo: {
    header: {
      title: 'Management of commission rates',
      subtitle: 'Manage vendor and buyer commission rates'
    },
    stats: {
      title: 'Brands in management'
    },
    wrapper: {
      giftCardsList: {
        title: 'Brands',
        subtitle: 'No active brand | One active Brand | {total} active brands',
        filters: {
          giftCards: 'Search a brand',
          sellers: 'Search a supplier'
        }
      },
      title: `Brand rate management`,
      subtitle: 'No supplier found | One supplier found | {total} suppliers found',
      sellersList: {
        btnAddSeller: 'Add a seller',
        titleBtnOpen: `See more information`,
        titleBtnClose: `See less information`,
        lastUpdate: 'Last modification',
        never: 'None',
        informations: {
          title: 'General supplier information',
          col1: 'Commission rate',
          col2: 'Payment of VAT',
          col3: 'Commission payment method',
          col4: 'VAT payment mode',
          col5: 'Method of payment to the supplier',
          col6: 'API',
          col7: 'Payment mode'
        },
        characteristicDeferred: {
          title: 'Deferred payment\'s characteristics',
          col1: 'Deferred limit',
          col2: 'Deferred used',
          col3: 'Deferred time',
          col4: 'Deferred deadline',
        },
        buyersTable: {
          title: 'Buyers informations',
          btnAdd: 'Add a buyer',
          col1: 'Buyer',
          col2: 'Commission rate',
          col3: 'Margin',
          col4: 'VAT',
          col5: 'Commission compensation mode',
          col6: 'Payment mode',
        }
      }
    },
    rateChangeSchedule: {
      popover: {
        title: 'Rate planning',
        inputBuyer: 'Choose a buyer',
        inputAmount: 'Enter a rate',
        inputTime: 'Choose a day and time',
        btnSave: 'Save',
        btnAdd: 'Plan a rate',
        rules: {
          buyer: 'Buyer is required',
          amount: 'Amount is required',
          time: 'Date and time are required',
        },
        notification: {
          success: {
            title: 'Planned rate',
            subtitle: 'The rate was planned successfully'
          },
          update: {
            title: 'Updated',
            subtitle: 'Planned rate was successfully changed'
          },
          error: {
            title: 'Error',
            subtitle: 'Rate could not be scheduled'
          }
        }
      },
      card: {
        title: 'Planned rate',
        on: 'on',
        notification: {
          success: {
            title: 'Success',
            subtitle: 'The planned rate has been deleted'
          },
          error: {
            title: 'Error',
            subtitle: 'The planned rate could not be deleted'
          }
        }
      }
    }
  },
  buyersManagement: {
    header: {
      title: 'Buyers management',
      subtitle: 'Manage buyers\' deposit account',
      btnAdd: 'Add a buyer'
    },
    stats: {
      title: 'Managed buyers'
    },
    card: {
      remainingBalance: 'Available balance',
      btnTopup: 'Top-up',
      btnEditDetails: 'Éditer / Détails'
    },
    table: {
      noMore: 'You have come to the end',
      noResults: 'No result',
      btnMore: 'Load more buyers'
    }
  },
  customers: {
    filters: {
      title: 'Filters',
      subtitle: 'Get better results using our smart filters',
      cancel: 'Cancel',
      apply: 'Apply',
      moreFiltersBtn: 'More filters',
      firstname: 'First name',
      lastname: 'Last name',
      email: 'Email',
      emailDomain: 'Email domain',
      personalEmail: 'Personal email',
      personalEmailDomain: 'Personal email domain',
      businessEmail: 'Business email',
      businessEmailDomain: 'Business email domain',
      confirmed: 'Confirmed',
      approval: 'Approval',
      lockedOnly: 'Show only locked accounts',
      registrationFailureReason: 'Registration failure reason',
      program: 'Program',
      dateRange: 'Date range',
      dateRangePlaceholder: {
        separator: 'to',
        start: 'Start date',
        end: 'End date'
      },
      sortByDate: 'Sort by date',
      sortByUpdate: 'Sort by update',
      sortByName: 'Sort by name',
      sortByDateOptions: {
        desc: 'Most recent',
        asc: 'Oldest'
      },
      sortByUpdateOptions: {
        desc: 'Most recent',
        asc: 'Oldest'
      },
      sortByNameOptions: {
        asc: 'A-Z',
        desc: 'Z-A'
      },
      confirmedOptions: {
        notConfirmed: 'Not confirmed',
        confirmed: 'Confirmed'
      },
      approvalOptions: {
        waiting: 'Waiting',
        verification_failed: 'Verification failed',
        verified: 'Verified'
      },
      registrationFailureReasonOptions: {
        no_reason: 'No reason',
        bad_email: 'Invalid email',
        domain_unknown: 'Unknown domain',
        catch_all_domain: 'Catch-all domain',
        unknown_email: 'Unknown email',
        risky_email: 'Risky email',
        mailgun_failed: 'Mailgun failed'
      },
      postalCode: 'Postal code',
      postalCodePlaceholder: 'Ex: 75 or 75000',
      postalCodeHelp: '2 digits = department, 5 digits = full postal code',
      situation: 'Situation',
      situationOptions: {
        employee: 'Employee',
        retired: 'Retired'
      }
    },
    header: {
      title: 'Customers management',
      subtitle: 'Find the personal information of your customers',
      beneficiariesTitle: 'Beneficiaries',
      beneficiariesSubtitle: 'Track and manage the beneficiaries of your program',
      btnAdd: 'Add a customer',
      btnDomains: 'List of accepted domains',
      btnAddDomain: 'Add domain',
      btnAddShort: 'Add',
      btnDomainsShort: 'Accepted domains',
      btnImport: 'Import',
      export: 'Export',
      exportExcel: 'Export to Excel',
      exportCSV: 'Export to CSV'
    },
    table: {
      beneficiary: 'Beneficiary',
      email: 'Email',
      app: 'App',
      actions: 'Actions',
      countLabel: 'beneficiary(ies)'
    },
    stats: {
      title: 'No. of customers :',
      filtered: '{count} customers match your filters',
      noFilter: 'No filter applied'
    },
    card: {
      phone: 'Phone',
      situation: 'Situation',
      retired: 'Retired',
      employee: 'Employee',
      program: 'Program',
      zipcode: 'Zip code',
      approved: 'Approved',
      locked: 'Account locked',
      unlocked: 'Account unlocked',
      lockedDescription: 'Lock the account to prevent access in case of suspicious activity or fraud',
      trusted: 'Trusted account',
      notTrusted: 'Account not trusted',
      trustedDescription: 'Mark the account as trusted so it will no longer be locked automatically',
      yes: 'Yes',
      auto: 'Auto',
      manual: 'Manual',
      waiting: 'Waiting for email confirmation',
      no: 'No',
      notSpecified: 'Unspecified',
      confirmedShort: 'Email confirmed',
      confirmedLong: 'Email confirmed (Login)',
      confirmedOptions: {
        notConfirmed: 'No',
        confirmed: 'Yes at'
      },
      btnEdit: 'Edit',
      btnVerify: 'Approve',
      btnDelete: 'Delete',
      popConfirmDelete: {
        title: 'Are you sure you want to delete this customer ?',
        confirmBtn: 'Confirm',
        cancelBtn: 'Cancel',
      },
      btnInvalidate: 'Unapprove',
      popoverFailure: {
        no_reason: 'No reason',
        domain_unknown: 'The domain is not referenced',
        bad_email: 'The business email does not exist for Avantages IEG',
        catch_all_domain: 'The domain accepts all emails',
        unknown_email: 'The status of the business email is unknown',
        risky_email: 'The email is risky',
        mailgun_failed: 'Mailgun failed',
      },
      popover: {
        titleVerify: 'Customer approval',
        titleInvalidate: 'Customer unapproval',
        subtitleInvalidate: 'Are you sure you want to unapprove this client?',
        subtitleForceVerifyEmail: 'Are you sure you want to force the approval of this client? The email is not confirmed.',
        subtitleForceVerify: 'Are you sure you want to force the approval of this client?',
        subtitleVerify1: 'By approving this client, the domain',
        subtitleVerify2: 'will be added to the list of accepted domains.',
        subtitleVerify3: 'Clients awaiting approval with this domain will be automatically approved.',
        abortBtn: 'Cancel',
        verifyBtn: 'Approve',
      }
    },
    pagination: {
      btnMore: 'See more customers',
      noMore: 'You have come to the end',
    },
    notification: {
      delete: {
        success: {
          title: 'Success',
          subtitle: 'Customer deleted'
        },
        error: {
          title: 'Error',
          subtitle: 'Customer could not be deleted'
        }
      },
      verification: {
        success: {
          title: 'Success',
          subtitle: 'Customer has been updated'
        },
        error: {
          title: 'Error',
          subtitle: 'Customer could not be updated'
        }
      },
      export: {
        success: {
          title: 'Export successful',
          subtitle: 'Excel file has been generated successfully'
        },
        error: {
          title: 'Export error',
          subtitle: 'An error occurred while generating the Excel file'
        }
      }
    },
    import: {
      title: 'Import customers',
      subtitle: 'Import customers from a CSV or Excel file. Failed rows do not block the creation of the others.',
      columnsTitle: 'Expected columns (separator ;)',
      required: 'required',
      optional: 'optional',
      downloadTemplate: 'Download CSV template',
      downloadTemplateExcel: 'Download Excel template',
      acceptHint: 'Accepted formats: .csv, .txt, .xlsx, .xls',
      loading: 'Import in progress…',
      loadingPrograms: 'Loading programs…',
      uploading: 'Uploading file…',
      uploadingTitle: 'Preparing file',
      cancel: 'Cancel',
      close: 'Close',
      submit: 'Import',
      importAnother: 'Import another file',
      resultTitle: 'Import complete',
      resultErrorTitle: 'Import failed',
      resultSubtitle: '{success} created, {fails} failed',
      resultErrorSubtitle: '{fails} row(s) with errors in the file',
      successCount: '{count} customer(s) created',
      failsCount: '{count} failed row(s)',
      fileError: 'File error',
      programLabel: 'Program',
      programPlaceholder: 'Select a program',
      programSelected: 'Program: {name}',
      selectProgramFirst: 'Select a program to enable upload',
      noProgram: 'No program available for this account.',
      columns: {
        firstname: 'First name',
        lastname: 'Last name',
        email: 'Email',
        phone_number: 'Phone'
      },
      notification: {
        doneTitle: 'Import complete',
        errorTitle: 'Import error'
      },
      errors: {
        EMAIL_ALREADY_EXISTS: 'This email already exists',
        MISSING_EMAIL: 'Missing email',
        MISSING_FIRSTNAME: 'Missing first name',
        MISSING_LASTNAME: 'Missing last name',
        INVALID_EMAIL_FORMAT: 'Invalid email format',
        PROGRAM_NOT_EXIST: 'Program not found',
        UNSUPPORTED_FILE_FORMAT: 'Unsupported file format',
        UNHANDLED_PARSING_ERROR: 'File parsing error',
        uploadFailed: 'File upload failed',
        loadPrograms: 'Unable to load programs',
        conflict: 'Import conflict (file already processed or import in progress). Retry with a new file.',
        generic: 'An error occurred during import',
        network: 'Network error (HTTP {status})',
        withLine: 'Line {line}: {message}',
        unknown: 'Error: {code}'
      }
    }
  },
  nativeAppUsers: {
    header: {
      title: 'Native app users',
      subtitle: 'Track adoption and activity of the Avantages IEG mobile app'
    },
    stats: {
      totalCustomers: 'Registered customers',
      connected: 'Connected to the app',
      notConnected: 'Never connected',
      adoptionRate: 'Adoption rate',
      recentConnections: 'Connections (last 30 days)'
    },
    filters: {
      search: 'Search by name or email',
      connectionStatus: 'Native app connection',
      all: 'All',
      connected: 'Connected',
      notConnected: 'Not connected'
    },
    table: {
      name: 'Name',
      email: 'Email',
      situation: 'Situation',
      zipcode: 'Zip code',
      nativeApp: 'Native app',
      lastConnection: 'Last connection',
      empty: 'No customers found'
    },
    pagination: {
      btnMore: 'See more customers'
    }
  },
  payVat: {
    yes: 'Yes',
    no: 'No',
    intracom: 'Intra-Community',
  },
  offset: {
    complete: 'Full offset',
    partial: 'Partial offset',
    no: 'No offset',
  },
  partialModeOffset: {
    instantPartial: 'Instant Partial Offset',
    differedPartial: 'Deferred Partial Offset',
    manualPartial: 'Manual Partial Offset',
  },
  vatPayBack: {
    bankTransfer: 'Bank transfer',
    prepaidAccount: 'Credit on prepaid account',
    instantPartial: 'Instant partial offset',
    inCommission: 'N/A',
    no: 'No VAT payback',
  },
  deferredDeadline: {
    atInvoiceReception: 'Upon receipt of the invoice ',
    atEndOfMonth: 'End of the month'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme color',
    showSidebarLogo: 'Sidebar logo',
    fixedHeader: 'Fixed header',
    sidebarTextTheme: 'Sidebar text theme'
  },
  status: {
    waiting: 'Waiting',
    processing: 'In progress',
    fulfilled: 'Fulfilled'
  },
  orderStatus: {
    waiting: 'Waiting for treatment',
    processing: 'Ongoing treatment',
    fulfilled: 'Fulfilled',
    suspended: 'Suspended',
    open: 'Open',
    cancelled: 'Cancelled'
  },
  paymentStatus: {
    refunded: 'Refunded',
    unpaid: 'Unpaid',
    paid: 'Paid',
    late: 'Late'
  },
  deliveryStatus: {
    delivered: 'Delivered',
    in_delivery: 'Partially delivered',
    undelivered: 'Undelivered'
  },
  activeCodes: {
    instant: 'Instant'
  },
  paymentMode: {
    prepaid: 'Prepaid',
    differed: 'Deferred',
    monthly: 'Monthly'
  },
  invoicePer: {
    invoice_per_order: 'Per order',
    invoice_per_month: 'Monthly'
  },
  retrievalMode: {
    title: 'Code recovery',
    api_retrieval: 'API',
    file_retrieval: 'File'
  },
  deliveryMode: {
    title: 'Delivery by',
    api_delivery: 'API',
    file_delivery: 'File'
  },
  kindPrepaidAccount: {
    vat: 'VAT',
    overpayment: 'Over payment',
    orderPayment: 'Bulk',
    topup: 'Bank transfer',
    fix: 'Correction',
    pull: 'API',
    orderPaymentCancellation: 'Bulk cancellation',
    topupCancellation: 'Topup cancellation',
    pullRefund: 'Pull refund',
    cardRefund: 'Card refund',
    reverseRefund: 'cancel refund'

  },
  orderFormDialog: {
    createOrderBtn: 'Place an order',
    titleUpdate: 'Edit an order',
    titleCreate: 'Create an order',
    infoGeneral: 'General informations',
    giftCard: 'Brands',
    selectGiftCard: 'Select a brand',
    paymentRule: 'Payment rule',
    paymentDelay: {
      title: 'Payment term',
      atReception: 'upon receipt',
      days: 'days'
    },
    drawingCeiling: {
      title: 'Drawing ceiling',
      unlimited: 'unlimited'
    },
    remainingDrawdownLimit: {
      title: 'Remaining draw capacity',
      unlimited: 'unlimited'
    },
    refCustomer: 'External transaction reference',
    opt: '(in option)',
    phrasing: {
      line1: 'Indicate here the transaction reference that you will use for your bank transfer.',
      line2: 'If not fill in please use order reference.'
    },
    retrievalMode: 'Delivery mode',
    retrievalModeOptions: {
      api: 'API',
      file: 'File'
    },
    retrievalModeHelp: 'Choose API if you want these codes to be stored in stock to pull them by API. Choose file, if you want to retrieve the codes via a file.',
    detailOrder: {
      title: 'Detail my order ?',
      yes: 'Yes',
      no: 'No'
    },
    formDetails: {
      alert: {
        title: 'Currently',
        title2: 'on an order of',
        compliant: 'The detail of your order is equal to the total amount of the order in face value.',
        improper: 'The detail is not equal to the total amount of the order in face value.'
      },
      amountCards: 'Number of card(s)',
      amount: 'Amount (€)',
      amountCardsReserved: 'Card to be reserved',
      tooltipCardsReserved: 'The quantity of card in reserve status will be reserved to supply manually or automatically the closed orders of the buyers',
      requiredQuantity: 'Quantity is required',
      amountRequired: 'Amount is required',
    },
    summary: {
      title: 'You currently have a prepaid balance of',
      title2: 'on your account.',
      title3: 'Do you want to use it for this order ?',
      balanceToUse: 'Balance to use',
      btnMax: 'Max',
      amountDetails: 'Amount detail to be paid',
      faceValue: 'Face value',
      commissionTTCPercentage: 'Commission with VAT in %',
      commissionTTCValue: 'Commission with VAT in value',
      commissionHT: 'Commission without VAT',
      credit: 'Credit note',
      creditTips: 'Credit note corresponding to the distribution commission VAT.',
      amountAfterDiscount: 'Amount after discount',
      prepaidAccount: 'Available balance',
      defferedUsage: 'Deferred use',
      remainingAmount: 'Remaining amount due',
      haveCredited: 'Credit note issued',
      pendingPayment: 'Credit note waiting for payment'
    },
    rules: {
      requiredGiftCard: 'Gift Card is required',
      requiredAmount: 'Amount order is required',
      detailsNotEqual: 'The total detail is not equal to the order amount'
    },
    notification: {
      create: {
        title: 'Order created',
        message: 'The order has been created successfully'
      },
      update: {
        title: 'Order updated',
        message: 'The order has been updated'
      },
      error: {
        title: 'Order not created',
        message: 'An error occured'
      },
      delete: {
        title: 'Deleted order',
        message: 'The order has been deleted successfully'
      }
    },
    btnOrder: 'Order',
    btnUpdate: 'Update'
  },
  deliveries: {
    card: {
      title: 'Deliveries',
      btnSee: 'Detail / Download',
      totalOfCodes: 'Total of codes',
      totalOfCodesByAPI: 'Distributed by API',
      totalOfCodesByFile: 'Distributed by File',
      file: 'File',
      downloaded: 'Téléchargé',
      yes: 'Oui',
      partially: 'Partiellement',
      no: 'Non'
    },
    dialog: {
      title: 'My deliveries',
      files: {
        codeFileBlank: 'No file generated',
        status: {
          title: 'Status',
          generated: 'Ready to download',
          notGenerated: 'Not generated',
        },
        detail: {
          title: 'Delivery detail',
        },
        download: {
          firstDownload: 'First downloaded on',
          lastDownload: 'Last downloaded on',
        },
        btn: {
          launchDownload: 'Launch download',
          generatePDFBtn: 'Generate PDFs',
          fileGenerating: 'Generation in progress...',
          generateAndDonwload: 'Generate and download the file',
          confirm: {
            title: 'Are you sure you want to generate a code file without PDF?',
            opt1: 'Cancel',
            opt2: 'Confirm',
          }
        }
      }
    }
  },
  createBuyerDialog: {
    createTitle: 'Creation of a buyer',
    updateTitle: 'Update a buyer',
    nameInput: `Namne of the buyer`,
    codeInput: 'Buyer prefix',
    rcsInput: 'Trade and company register',
    intraVatNumberInput: 'Intra-community VAT N°',
    sirenInput: 'Trade and company registry N°',
    createNewAccount: 'Create a user account for this buyer',
    accountFirstNameInput: 'First name',
    accountLastNameInput: 'Last name',
    accountEmailInput: 'Email',
    title2: 'Secondary informations',
    logoInput: `Buyer logo`,
    locationNameInput: 'Company name',
    locationLine1Input: 'Address',
    locationLine2Input: `Additional address`,
    locationZipCodeInput: 'Postal code',
    locationCityCodeInput: 'City',
    locationStateCodeInput: 'Country',
    abortBtn: 'Cancel',
    confirmBtn: `Confirm`,
    updateBtn: `Update`,
    createAccountBtn: `Create the account`,
    rules: {
      name: `The name of the buyer is required`,
      code: 'The buyer prefix is required',
      rcs: 'Trade and company register is required',
      intraVatNumber: 'Intra-community VAT N° is required',
      siren: 'Trade and company registry N° is required',
      locationName: 'Company name is required',
      locationLine1: `Address is required`,
      locationZipCode: 'Postal code is required',
      locationCity: `The city is required`,
      locationState: 'The country is required',
      firstname: 'First name is required',
      lastname: 'Last name required',
      email: `Email is required`,
    },
    notifications: {
      success: {
        title: 'Buyer created',
        subtitle: `Buyer created successfully`
      },
      error: {
        title: 'Error',
        subtitle: `The buyer could not be created`
      },
      successUpdate: {
        title: 'Buyer updated',
        subtitle: 'Buyer updated successfully'
      },
      successAccount: {
        title: 'Account created',
        subtitle: `Buyer account has been created`
      },
      errorAccount: {
        title: 'Error',
        subtitle: `The buyer account could not be created`
      }
    }
  },
  topupBuyerDialog: {
    title: 'Top-up',
    amountInput: 'Amount (€)',
    referenceInput: 'Bank transfer reference',
    sendAtInput: 'Performed on',
    sendAtPlaceholder: 'Select date and time',
    abortBtn: 'Cancel',
    confirmBtn: 'Confirm',
    rules: {
      amount: 'An amount is required',
      reference: 'Bank transfer reference is required',
      sendAt: 'Bank transfer date is required'
    },
    notifications: {
      success: {
        title: `Buyer has been credited`,
        subtitle: 'credited with'
      },
      error: {
        title: `An error has occured`,
        subtitle: `The buyer could not be credited`
      }
    }
  },
  customerDialog: {
    approvedAuto: 'Customer automatically approved',
    approvedManual: 'Customer manually approved',
    createTitle: 'New customer',
    updateTitle: 'Update customer',
    firstnameInput: 'First name',
    lastnameInput: 'Last name',
    businessEmailInput: 'Business email',
    checkEmailBtn: 'Check email',
    emailInput: 'Login email',
    zipcodeInput: 'Zip code',
    emailConfirmation: {
      confirmedByEmail: 'Confirmed by email on',
      notConfirmed: 'Email not confirmed',
      confirmedManually: 'Confirmed manually',
      validationInProgress: 'is in validation'
    },
    emailConfirmationStatus: {
      title: 'Email status',
      accepted: 'In queue',
      rejected: 'Rejected',
      delivered: 'Delivered',
      failed: 'Failed',
      opened: 'Opened',
      clicked: 'Clicked',
      unsubscribed: 'Unsubscribed',
      complained: 'Complained',
      stored: 'Stored',
      on: 'on'
    },
    optinNewsletterInput: 'The client wants to receive newsletters',
    codeCniegInput: 'CNIEG code',
    situationInput: 'Situation',
    retired: 'Retired',
    employee: 'Employee',
    phoneInput: 'Phone number',
    programInput: 'Program',
    abortBtn: 'Cancel',
    confirmBtn: 'Create customer',
    updateBtn: 'Update',
    rules: {
      firstname: 'First name is required',
      lastname: 'Last name is required',
      email: 'Email is required',
      programId: 'Program is required',
      zipcode: 'Zip code must be 5 digits'
    },
    notifications: {
      success: {
        title: 'Success',
        subtitle: 'Customer has been created'
      },
      update: {
        title: 'Success',
        subtitle: 'Customer has been updated'
      },
      error: {
        title: `An error has occurred`,
        subtitle: `Customer could not be created or updated`
      },
      checkEmailSuccess: {
        title: 'Success',
        subtitle: 'Email has been checked with status:'
      },
      checkEmailError: {
        title: 'An error has occurred',
        subtitle: 'Email could not be checked'
      }
    }
  },
  manageDomainDialog: {
    title: 'List of accepted domains',
    selectLabelProgram: 'Domains of program :',
    selectPlaceholderProgram: 'Select a program',
    domainSearchInput: 'Search for a domain',
    popconfirmDelete: {
      title: 'Are you sure you want to delete this domain?',
      cancelBtn: 'Cancel',
      confirmBtn: 'Confirm'
    },
    popoverAdd: {
      title: 'Domain to accept',
      subtitle: 'Enter a domain to add to the list',
      abortBtn: 'Cancel',
      confirmBtn: 'Confirm',
      addDomainBtn: 'Add a domain',
      rules: {
        domainRequired: 'Domain is required',
        domainInvalid: 'Domain is invalid',
      }
    },
    notifications: {
      success: {
        title: 'Succès',
        message: 'Liste de domaine à étè mise à jour'
      },
      error: {
        title: 'Une erreur s\'est produite',
        message: 'Liste de domaine n\'a pas pu être modifier'
      }
    }
  },
  purchaseInfoBuyerDialog: {
    createTitleSeller: `Adding a seller for`,
    updateTitleSeller: `Seller update for`,
    createTitle: 'Assignment of a buyer',
    updateTitle: 'Update a buyer',
    form: {
      titleInformations: 'General information',
      inputSeller: 'Seller',
      inputBuyer: 'Buyer',
      inputPayVat: 'Payment of VAT',
      inputOffset: 'Commission offset mode',
      inputPartialModeOffset: 'VAT payment mode',
      inputDifferedPartialOffset: 'Deadline for payment of VAT (in days)',
      inputVatPayBack: 'VAT offset mode',
      inputPaymentMode: 'Payment mode',
      titleRate: 'Commission rate setup',
      inputRate: 'Commission rate (%)',
      titleDeferred: 'Deferred payment characteristics',
      inputDeferredAmountLimit: 'Deferred limit',
      inputDeferredAmountUsage: 'Deferred available',
      inputDeferredDuration: 'Deferred time',
      inputInvoiceAt: 'Invoice',
      inputApiEnable: 'API enabled ?',
      apiEnableOptions: {
        yes: 'Yes',
        no: 'No',
      },
      btnCreateSeller: `Add seller`,
      btnUpdateSeller: `Update seller`,
      btnCreate: `Add a buyer`,
      btnUpdate: `Update the buyer`,
      btnAbort: 'Cancel',
      notification: {
        success: {
          title: 'Creation of purchase information',
          subtitle: 'The buyer has been added'
        },
        successSeller: {
          title: `Adding a new seller`,
          subtitle: `Seller has been added`
        },
        update: {
          title: 'Done',
          subtitle: 'Purchase information update'
        },
        updateSeller: {
          title: `Success`,
          subtitle: `Update seller purchase information`
        },
        error: {
          title: 'Error',
          subtitle: 'An error occured while adding buyer'
        },
        errorSeller: {
          title: 'Error',
          subtitle: `An error occurred while adding the seller`
        }
      }
    }
  },
  detailsDialog: {
    ref: 'Ref',
    trackingControl: 'Delivery tracking',
    subtitle: 'Follow in real time the status of your delivery',
    status: {
      undelivered: 'Undelivered',
      inDelivery: 'In delivery',
      complete: 'Delivered'
    },
    codeDeliveries: 'Code deliveries',
    deliveriesSubtitle: 'List of code deliveries related to this order',
    deliveriesList: {
      delivery: 'Code(s) delivered: {sum} out of {total} | Code(s) delivered: {sum} out of {total} | Code(s) delivered: {sum} out of {total}',
      activationDate: 'Activation date',
      inactiveCode: 'Inactive code(s)',
      amountTotal: 'Total amount',
      deliveryDetails: 'Order detail',
      equalAmount: '{quantity} card for an amount equal to {amount} | {quantity} card(s) for an amount equal to {amount} | {quantity} card(s) for an amount equal to {amount}',
      quantityReserved: ', including {quantityReserved} reserved card | , including {quantityReserved} reserved cards | , including {quantityReserved} reserved cards',
      empty: 'Not specified',
      downloadFile: 'Download the code file in .CSV'
    },
    remainingDraw: 'Remaining draw',
    subtitleDetail: 'Order detail',
    notSpecified: 'Not specified',
    downloadStandardInvoiceBtn: 'Download the standard invoice',
    downloadCommissionInvoiceBtn: 'Download the commission invoice'
  },
  uploadCodes: {
    errors: {
      CODE_DUPLICATION: 'Code duplication(s) in file',
      CODE_ALREADY_EXISTS: 'Code(s) already delivered in previous order',
      SKU_NOT_FOUND: 'Non-existent face value(s) in order detail',
      CODE_NOT_ORDERED: 'Extra code(s)',
      UNHANDLED_PARSING_ERROR: 'File is not readable.',
      NEGATIVE_AMOUNT: 'Negative face value(s)',
      MISSING_CODE: 'Code(s) missing',
      INVALID_EXPIRY_DATE: 'Expiry date is invalid'
    },
    found: 'error(s) found'
  },
  components: {
    changeLanguageTips: 'Switch Language Success',
    copySuccess: 'The value has been copied',
    copyError: 'The value could not be copied'
  },
  common: {
    noData: "There is no data to display",
    line: "Line",
    copy: "Copy",
    cancel: "Cancel",
    apply: "Apply"
  },
  delete: {
    title: 'Are you sure you want to delete this ?',
    abort: 'Cancel',
    confirm: 'Confirm',
    notification: {
      success: {
        title: 'Done',
        subtitle: 'Deleted successfully'
      },
      error: {
        title: 'Error',
        subtitle: 'An error occured'
      }
    }
  },
  roles: {
    seller: 'seller',
    wholesaler: 'wholesaler',
    buyer: 'buyer',
    caretaker: 'caretaker'
  },
  gifts: {
    uploadDialog: {
      title: 'New gift campaign',
      openBtn: 'Import gift campaign',
      file: 'CSV or Excel file',
      mandatoryField: '(Accepted formats: .csv, .xls, .xlsx)',
      mandatoryFieldCSV: '(Accepted formats: .csv, .xls, .xlsx)',
      fileIsRequired: 'File is required',
      cancelBtn: 'Cancel',
      uploadBtn: 'Import',
      processing: 'Processing file...',
      preparing: 'Preparing file...',
      updating: 'Updating data...',
      sending: 'Sending...',
      importComplete: 'Import complete',
      cardsCreated: 'card(s) processed',
      importErrors: 'import error(s)',
      verifyData: 'Please verify that the imported data is correct. You can modify it if necessary before final campaign submission.',
      searchFilters: 'Search filters',
      clearFilters: 'Clear filters',
      searchBy: 'Search by',
      search: 'Search',
      showOnlyErrors: 'Show only errors',
      errorLines: 'line(s) with error',
      downloadModifiedCsv: 'Download modified CSV',
      changeFile: 'Change file',
      launchCampaign: 'Launch gift campaign',
      selectCard: 'Select a card',
      confirmation: {
        title: 'Launch gift campaign',
        subtitle: 'Are you sure you want to launch this gift campaign?',
        confirm: 'Yes, launch campaign',
        cancel: 'No, check again'
      },
      notification: {
        success: {
          title: 'Success',
          message: 'File has been imported successfully'
        },
        error: {
          title: 'Error',
          message: 'An error occurred during import'
        }
      },
      errors: {
        noData: 'File contains no data',
        noOperation: 'No operation selected',
        validation: 'Validation error',
        validationWithCode: 'Validation error (422)',
        generic: 'An error occurred while processing the file',
        formValidation: 'Please correct all errors before submitting the form',
        unsupportedFormat: 'Unsupported file format. Please use a CSV, XLS or XLSX file.',
        missingHeaders: 'File is missing required columns: {fields}',
        readError: 'Error while reading the file',
      },
      csvFormat: {
        title: 'Expected file format',
        description: 'The file must contain the following columns (CSV with semicolon separator or Excel sheet):',
        columns: {
          firstname: 'Recipient first name',
          lastname: 'Recipient last name',
          email: 'Email address',
          multi_choice_gift_card: 'Gift card name',
          amount: 'Amount in euros (integer)',
          scheduled_at: 'Send date (format: dd/mm/yyyy)',
        },
        note: 'CSV columns must be separated by semicolons (;). For Excel, use the first sheet of the workbook.'
      },
      downloadTemplate: 'Download CSV template',
      downloadTemplateExcel: 'Download Excel template',
      createNewTable: 'Create new table',
      addRow: 'Add row',
      errorCopied: 'Error copied to clipboard',
      recipientInfo: 'Recipient',
      emailInfo: 'Email',
      copySuccess: 'Copied to clipboard',
      copyError: 'Unable to copy to clipboard',
    },
    validation: {
      errors: {
        unknown: 'Unknown error',
        field_required: 'The {field} field cannot be empty',
        fieldRequired: 'The {field} field is required',
        invalid_email: 'Invalid email format',
        invalid_gift_card: 'Gift card not available in this program',
        invalid_amount: 'Amount must be an integer',
        invalid_date: 'Date must be in dd/mm/yyyy format',
        invalid_date_value: 'Invalid date',
        code_duplication: 'Duplicate code(s) in file',
        code_already_exists: 'Code(s) already delivered in previous order',
        sku_not_found: 'Face value(s) not found in order detail',
        code_not_ordered: 'Extra code(s)',
        unhandled_parsing_error: 'File is not readable',
        negative_amount: 'Negative face value(s)',
        missing_code: 'Missing code(s)',
        generic: 'An error occurred',
        invalidEmail: 'Invalid email format',
        invalidDate: 'Date must be in dd/mm/yyyy format',
        invalidAmount: 'Amount must be an integer',
        invalidGiftCard: 'Gift card not available in this program',
        date_in_the_past: 'Scheduled send date cannot be earlier than today',
        scheduledAtPast: 'Scheduled send date cannot be earlier than today'
      }
    },
    extendDialog: {
      title: 'Extend expiration',
      tooltip: 'Extend expiration',
      notExtendableTooltip: 'Extension unavailable for a fully used card',
      notExtendableBlankTooltip: 'Extension unavailable for a blank allocation',
      card: 'Card',
      count: 'Number of allocations',
      currentExpiration: 'Current expiration',
      notSet: 'Not set',
      durationLabel: 'Extension duration (days)',
      durationRequired: 'Enter a number of days',
      daysUnit: 'days',
      lastExtension: 'Last extension on {date} (+{duration} days)',
      activePreview: '{count} active card(s): current expiration + {days} days',
      expiredPreview: '{count} expired card(s): today + {days} days',
      atomicWarning: 'If one card fails, no extension will be applied (all-or-nothing transaction).',
      submitBtn: 'Extend',
      confirmTitle: 'Confirm extension by {days} days?',
      notification: {
        success: {
          title: 'Success',
          message: 'Expiration extended by {days} days'
        },
        error: {
          title: 'Error',
          fallback: 'An error occurred while extending expiration'
        }
      }
    },
    extendBulkDialog: {
      title: 'Extend multiple allocations',
      actionBtn: 'Extend {count} allocation(s)',
      confirmTitle: 'Confirm extension by {days} days for {count} allocation(s)?',
      notification: {
        success: {
          message: 'Expiration extended by {days} days for {count} allocation(s)'
        }
      }
    },
    redemptionPdf: {
      generateBtn: 'Generate PDF',
      downloadBtn: 'Download PDF',
      generateTooltip: 'Generate a PDF voucher with a code so the recipient can access their gift',
      downloadTooltip: 'Download the PDF voucher already generated',
      notification: {
        error: {
          title: 'Error',
          fallback: 'Unable to generate the PDF'
        }
      }
    },
    resendEmailDialog: {
      title: 'Edit email and resend',
      actionTooltip: 'Edit email and resend the gift',
      limitReachedTooltip: 'Limit of 3 resends reached',
      currentEmail: 'Current email',
      failureReason: 'Failure reason',
      newEmail: 'New email',
      invalidEmail: 'Please enter a valid email',
      accountWarning: `The email will be changed on the recipient's whole account (all their cards).`,
      remaining: 'Resends left: {count}',
      closeBtn: 'Cancel',
      submitBtn: 'Resend',
      notification: {
        success: {
          title: 'Email resent',
          message: 'The gift was resent to the new address'
        },
        error: {
          title: 'Error',
          fallback: 'Unable to resend the email'
        }
      }
    },
    revokeDialog: {
      title: 'Cancel allocation',
      tooltip: 'Cancel allocation',
      beneficiary: 'Recipient',
      blankCard: 'Blank card',
      card: 'Card',
      amount: 'Amount',
      emailWarningPreIssue: 'A delivery email has already been sent to the recipient. Cancellation is still possible, but the email cannot be recalled.',
      emailWarningDynamic: 'A delivery email for this allocation has already been sent to the recipient. Cancellation is still possible, but the email cannot be recalled. The recipient may still click the link sent, but no allocation will be shown when they sign in.',
      descriptionBlankUnassigned: 'This action will delete this blank allocation and credit your allocation advance. The blank allocation will be removed.',
      descriptionPreIssueAssigned: 'This action will remove the allocation from its recipient. The allocation will become blank again and be available to assign to a future recipient.',
      descriptionDynamicAssigned: 'This action will cancel the allocation and credit your allocation advance. The allocation will be deleted.',
      notRevocableUsedTooltip: 'Card already used',
      closeBtn: 'Close',
      submitBtn: 'Cancel allocation',
      confirmTitle: 'Confirm cancellation of this allocation?',
      notification: {
        success: {
          title: 'Success',
          message: 'Allocation cancelled successfully'
        },
        error: {
          title: 'Error',
          fallback: 'An error occurred while cancelling the allocation'
        }
      }
    },
    revokeBulkDialog: {
      title: 'Cancel multiple allocations',
      actionBtn: 'Cancel {count} allocation(s)',
      count: 'Number of allocations',
      totalAmount: 'Total amount',
      emailWarning: 'A delivery email has already been sent for at least one allocation. Cancellation is still possible, but emails cannot be recalled.',
      atomicWarning: 'If one card fails, none will be cancelled (all-or-nothing transaction).',
      descriptionMixed: 'This action will cancel or remove the selected allocations and credit your allocation advance according to each allocation type.',
      closeBtn: 'Close',
      submitBtn: 'Confirm cancellation',
      confirmTitle: 'Confirm cancellation of {count} allocation(s)?',
      notRevocableTooltip: 'Card already used',
      notification: {
        success: {
          title: 'Success',
          message: '{count} allocation(s) cancelled'
        },
        error: {
          title: 'Error',
          fallback: 'An error occurred while cancelling the allocations'
        }
      }
    }
  },
  enrollment: {
    steps: {
      structure: 'Your organization',
      bankCards: 'Bank card',
      validation: 'Validation'
    },
    navigation: {
      previous: 'Previous step',
      next: 'Next step',
      submit: 'Confirm enrollment',
      legalNote: 'Free enrollment · By continuing you accept our terms and privacy policy.'
    },
    common: {
      yes: 'Yes',
      no: 'No'
    },
    rgpd: {
      title: 'Before you start',
      description: 'Carrefour Pro would like to share your business data with Browse&Go, the Pass Avantage operator, to pre-fill your enrollment form.',
      dataTitle: 'Data concerned:',
      dataList: 'Company name, SIRET, billing address, main contact details',
      dataDelivery: ', delivery site addresses',
      refusalNote: 'If you refuse, no data will be shared and you will fill the form manually. This does not affect your access to Pass Avantage.',
      accept: 'I accept — pre-fill my form',
      refuse: 'I refuse — I will enter my data manually'
    },
    prefill: {
      loading: 'Fetching your information…',
      error: 'Unable to retrieve your information. You can continue your enrollment manually.',
      prefilledBadge: 'Pre-filled',
      successBanner: 'Some information has been pre-filled. Please review it before continuing.'
    },
    structure: {
      infoBanner: 'Complete the organization information to enroll. Fields marked "Imported" come from a partner source.',
      companyTitle: 'Your organization',
      companySubtitle: 'Legal information',
      adminTitle: 'Main contact',
      adminBadge: 'Administrator',
      adminSubtitle: 'This account will have admin rights and can create other users after enrollment',
      adminInfo: 'This person will be the main Pass Avantage administrator and can invite team members.',
      billingTitle: 'Billing address',
      billingSubtitle: 'For invoice issuance',
      invoiceTitle: 'Invoicing',
      invoiceSubtitle: 'How would you like to receive your invoices?',
      deliveryTitle: 'Delivery addresses',
      deliverySubtitle: 'Sites for receiving physical bank card allocations (optional)',
      legalTitle: 'Terms and conditions',
      legalSubtitle: 'Read and accept before continuing'
    },
    fields: {
      companyName: 'Company name',
      entityKind: 'Organization type',
      entityKindPlaceholder: '— Select —',
      entityKindOther: 'Specify',
      siret: 'SIRET',
      siretHint: '14 digits',
      siren: 'SIREN (optional)',
      vatNumber: 'EU VAT number (optional)',
      rcs: 'Trade register (optional)',
      nafCode: 'NAF code (optional)',
      employeeRange: 'Number of employees (optional)',
      employeeRangePlaceholder: '— Range —',
      adminFullName: 'Full name',
      contactRole: 'Role',
      contactRolePlaceholder: '— Select —',
      contactRoleOther: 'Specify role',
      adminEmail: 'Business email',
      adminEmailHint: 'This email will be the login identifier',
      mobilePhone: 'Mobile phone',
      landlinePhone: 'Landline (optional)',
      password: 'Password',
      passwordConfirmation: 'Confirm password',
      streetNumber: 'Number (optional)',
      street: 'Street',
      city: 'City',
      zipcode: 'Postal code',
      country: 'Country',
      invoiceMode: 'Invoicing mode',
      invoiceMonthly: 'Monthly',
      invoicePerOrder: 'Per order',
      acceptedCgu: 'I have read and accept the Pass Avantage Terms and Conditions.',
      acceptedRgpd: 'I accept data processing in accordance with the GDPR Privacy Policy.',
      optinNewsletter: 'I agree to receive Pass Avantage news and offers by email or SMS. (Optional)',
      required: 'Required'
    },
    password: {
      title: 'Choose a password',
      subtitle: 'For the future admin account',
      hintDefault: 'At least 8 characters, one uppercase letter, one digit',
      tooShort: 'Too short',
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      matchDefault: 'Must match the password',
      matchOk: 'Passwords match',
      matchKo: 'Passwords do not match'
    },
    delivery: {
      prefillNotice: 'Addresses imported from the partner account. Review them below, you can edit or add more.',
      emptyHint: 'If you plan to order physical bank cards, you can add delivery addresses now or later.',
      newSite: 'New site',
      imported: 'Imported',
      siteName: 'Site name',
      siteNamePlaceholder: 'E.g. Head office, Lyon site…',
      street: 'Street',
      streetPlaceholder: 'Street number and name',
      city: 'City',
      cityPlaceholder: 'E.g. Paris',
      zipcode: 'Postal code',
      zipcodePlaceholder: '75001',
      addSite: 'Add a delivery site'
    },
    bankCards: {
      standardTitle: 'Standard allocations — enabled by default',
      standardSubtitle: 'These options are active for all beneficiaries with no extra steps.',
      ecardCarrefour: 'Carrefour e-Card',
      ecardEverywish: 'Everywish multi-brand e-Card',
      ecardBank: 'Bank e-Card (optional)',
      optionsTitle: 'Card options — activation requests',
      optionsSubtitle: 'These options require activation by our admin team',
      physicalQuestion: 'Do you plan to order physical bank cards?',
      physicalHint: 'Select YES if you want our admin team to activate this option. Default: No.',
      virtualQuestion: 'Do you plan to order virtual bank cards?',
      virtualHint: 'Select YES if you want our admin team to activate this option. Default: No.',
      adminNotice: 'You will be notified once these options are activated. Contact your account manager if needed.',
      physicalAddressesTitle: 'Delivery addresses for your sites',
      physicalAddressesSubtitle: 'Optional — you can provide them on your first order',
      physicalAddressesEmpty: 'Add at least one delivery address for physical cards.'
    },
    validation: {
      recapTitle: 'Enrollment summary',
      deliveryAddresses: 'Delivery addresses',
      deliveryCount: '{count} site(s) provided',
      deliveryLater: 'To be configured on first order',
      deliveryNone: 'No address provided',
      cardOptionsTitle: 'Requested bank card options',
      pending: 'Pending',
      journeyTitle: 'Your activation journey — right after this step',
      journeySubtitle: 'Your workspace will guide you through the next steps',
      journeyEmail: 'Confirm your email',
      journeyEmailDesc: 'A link is sent to {email}. One click activates the admin account.',
      journeyBeneficiaries: 'Import your beneficiaries',
      journeyBeneficiariesDesc: 'Import beneficiaries to give them access to the Advantage Program and mobile wallet.',
      journeyBalance: 'Fund your advance balance',
      journeyBalanceDesc: 'Your account starts with a zero balance. Fund it to issue allocations.',
      journeyOrders: 'Place your first allocation orders',
      journeyOrdersDesc: 'Christmas, profit-sharing, company events… Order from your admin space at your pace.',
      optional: 'Optional'
    },
    success: {
      title: 'One last click!',
      description: 'Enrollment is saved. To activate the admin account, click the confirmation link sent to',
      carrefourProId: 'Carrefour Pro ID',
      passAvantageId: 'Pass Avantage ID',
      nextBeneficiaries: 'Next step: upload your beneficiary base to open access to the Advantage Program.',
      nextBalance: 'Your advance balance is zero. You can fund it from your workspace to issue allocations.',
      noEmail: 'No email received? Check spam or contact support.',
      backToCustomers: 'Back to customers'
    },
    rules: {
      companyName: 'Company name is required',
      entityKind: 'Organization type is required',
      entityKindOther: 'Please specify the organization type',
      siret: 'SIRET is required',
      siretFormat: 'SIRET must contain 14 digits',
      adminFullName: 'Full name is required',
      contactRole: 'Role is required',
      contactRoleOther: 'Please specify the role',
      adminEmail: 'Business email is required',
      emailFormat: 'Please enter a valid email address',
      mobilePhone: 'Mobile phone is required',
      password: 'Password is required',
      passwordFormat: 'At least 8 characters, one uppercase letter and one digit',
      passwordConfirmation: 'Confirmation is required',
      passwordMismatch: 'Passwords do not match',
      street: 'Street is required',
      city: 'City is required',
      zipcode: 'Postal code is required',
      country: 'Country is required',
      siteName: 'Site name is required',
      legalRequired: 'Please accept the terms and privacy policy to continue'
    },
    customersEntry: 'Enroll an organization'
  },
  newDotationOrder: {
    steps: {
      orderType: 'Order type',
      nature: 'Allocation nature',
      cardOptions: 'Card options',
      distribution: 'Distribution',
      entry: 'Entry'
    },
    navigation: {
      previous: 'Previous step',
      next: 'Next step',
      submit: 'Confirm order'
    },
    orderType: {
      intro: 'Select the type of allocation you want to order for your beneficiaries.',
      comingSoon: 'Coming soon',
      standard: {
        title: 'Standard — beneficiary choice',
        description: 'Carrefour + Everywish e-Cards included. Bank e-Card option at next step.'
      },
      physical: {
        title: 'Physical bank card only',
        description: 'Prepaid Mastercard delivered physically on-site or at home.'
      },
      virtual: {
        title: 'Virtual bank card only',
        description: 'Prepaid bank e-Card issued instantly, no physical delivery.'
      }
    },
    nature: {
      intro: 'Choose the nature of your allocation order.',
      urssaf: {
        title: 'URSSAF allocation',
        description: 'Events eligible for social contribution exemption (Christmas, birth, wedding…). 2025 threshold: €193 per event.'
      },
      classic: {
        title: 'Classic allocation',
        description: 'Free allocation with no amount or event constraints.'
      },
      eventLabel: 'Event',
      eventPlaceholder: '— Select an event —'
    },
    event: {
      selected: 'Selected event: {name}',
      empty: 'No active URSSAF events available.',
      loadError: 'Unable to load URSSAF events.'
    },
    cardOptions: {
      includedCarrefour: 'Carrefour e-Card included',
      includedEverywish: 'Everywish e-Card included',
      optional: 'Optional',
      bankCardTitle: 'Prepaid bank e-Card',
      bankCardHint: 'Full freedom for beneficiary — {issuancePrice}/card + {loadingRate} loading fees',
      bankCardHintLoading: 'Full freedom for beneficiary — loading pricing…',
      fundingQuestion: 'Who pays for the card cost?',
      fundingBeneficiary: 'Beneficiary (deducted from allocation)',
      fundingOrganization: 'Organization (in addition to allocation)',
      issuanceSubsidyLabel: 'Issuance subsidy',
      loadingSubsidyLabel: 'Loading subsidy',
      provisionNotice: 'A 20% provision of the total order amount will be required at validation to cover bank e-card fee subsidies.'
    },
    distribution: {
      intro: 'How would you like to distribute the allocations?',
      single: {
        title: 'Single allocation',
        description: 'Manual entry for one beneficiary. Ideal for individual cases.'
      },
      csv: {
        title: 'CSV / Excel import',
        description: 'Import multiple beneficiaries from a file. Ideal for Christmas, summer, culture…'
      }
    },
    entry: {
      recapTitle: 'Summary',
      programLabel: 'Program',
      programPlaceholder: 'Select a program',
      programSelected: 'Program: {name}',
      noProgram: 'No program available for this account.',
      loadProgramsError: 'Unable to load programs.',
      beneficiaryCount: 'Number of beneficiaries',
      totalAmount: 'Total allocation amount',
      beneficiary: 'Beneficiary',
      beneficiaryPlaceholder: 'Search for a beneficiary',
      searchEmail: 'Email',
      firstname: 'First name',
      lastname: 'Last name',
      amount: 'Amount (€)',
      amountPlaceholder: '50',
      scheduledAt: 'Scheduled date',
      scheduledAtPlaceholder: 'DD/MM/YYYY',
      scheduledAtOptionalPlaceholder: 'DD/MM/YYYY (blank = send immediately)',
      clientReference: 'Client reference (optional)',
      clientReferencePlaceholder: 'REF-1234',
      csvColumnsTitle: 'Expected columns (separator ;)',
      downloadCsvTemplate: 'Download CSV template',
      downloadExcelTemplate: 'Download Excel template',
      csvDrop: 'Drop the file here or click to select',
      csvParsing: 'Reading file…',
      csvReadError: 'Unable to read the file.',
      csvTable: {
        headers: {
          firstname: 'First name',
          lastname: 'Last name',
          gender: 'Gender',
          email: 'Email',
          amount: 'Amount (€)',
          scheduled_at: 'Scheduled on',
          scheduledAtFormat: 'DD/MM/YYYY',
          customer_client_reference: 'Client reference'
        },
        addRow: 'Add row',
        deleteRow: 'Delete row',
        changeFile: 'Delete and import a new file',
        originalFile: 'Original file: {filename}',
        rowError: 'Line {line} — {field}: {message}',
        modifiedMessage: 'Do you want to generate the corresponding Excel file?',
        downloadModified: 'Download the new version',
        errors: {
          missingFirstname: 'First name required',
          missingLastname: 'Last name required',
          missingEmail: 'Email required',
          invalidEmail: 'Invalid email format',
          invalidAmount: 'Invalid amount (positive whole number required)',
          invalidDate: 'Invalid date (format DD/MM/YYYY)',
          dateInThePast: 'Date cannot be in the past',
          customerNotFound: 'No existing beneficiary matches this email'
        }
      }
    },
    success: {
      title: 'Order saved',
      description: 'Your allocation order has been created.',
      reference: 'Order reference',
      total: 'Total amount',
      counts: '{success} line(s) created, {fails} failed',
      failsDetailTitle: 'Failed lines',
      failRow: 'Line {rowNumber}: {message}',
      backToOrders: 'View my allocation order details'
    },
    rules: {
      nature: 'Allocation nature is required',
      urssafEvent: 'Event is required for URSSAF allocation',
      cardFunding: 'Please specify who funds the bank e-card',
      distributionMode: 'Distribution mode is required',
      program: 'Program is required',
      customer: 'Beneficiary is required',
      amount: 'Amount must be greater than 0',
      scheduledAt: 'Scheduled date is required',
      csv: 'Import file is required',
      csvInvalidRows: 'Fix the rows with errors before continuing'
    },
    notification: {
      errorTitle: 'Error',
      errorGeneric: 'The order could not be created.',
      csvRowError: 'Line {line}: {message}',
      partialTitle: 'Order created with errors',
      partialMessage: '{success} succeeded, {fails} failed.',
      classicUnavailable: 'Classic orders are not available via the API yet. Please choose a URSSAF allocation.'
    },
    headerCta: 'New allocation order'
  },
  dotationOrders: {
    breadcrumb: {
      dashboard: 'Dashboard',
      current: 'Orders and deposits list'
    },
    title: 'Orders and deposits list',
    subtitle: 'Track your multi-choice card orders and deposits',
    scheduledAt: 'Send date',
    budget: {
      total: 'Deposit balance',
      available: 'Available deposit balance',
      reserved: 'Reserved balance',
      reservedOrdersLabel: 'Attached order(s):'
    },
    newOrderCta: 'New allocation order',
    newAcompteCta: 'Make a deposit',
    empty: 'No orders or deposits yet. Start a new allocation order or make a deposit.',
    filters: {
      orders: 'Orders',
      acomptes: 'Deposits'
    },
    acompte: {
      label: 'Deposit',
      pendingHint: 'Free deposit order awaiting payment, please make your bank transfer with the following reference: {reference}',
      pendingHintReserved: 'Reserved deposit order awaiting payment, please make your bank transfer with the following reference: {reference}',
      status: {
        pending: 'Awaiting validation',
        validated: 'Validated'
      },
      actions: {
        delete: 'Delete this deposit'
      },
      delete: {
        confirmTitle: 'Delete this deposit',
        confirmMessage: 'Delete this deposit? This action cannot be undone.'
      }
    },
    status: {
      paid: 'Paid',
      confirmed: 'Confirmed',
      draft: 'Draft',
      unpaid: 'Awaiting payment'
    },
    beneficiaries: {
      title: 'Order lines',
      name: 'Beneficiary',
      email: 'Email',
      amount: 'Amount',
      emailStatus: 'Email status',
      action: 'Action',
      empty: 'No lines on this order'
    },
    schedule: {
      expiredMessage: 'This order was scheduled to be sent on {date}, a date already in the past. Choose how to proceed before paying:',
      sendNow: 'Send now',
      applyDate: 'Apply this date',
      datePlaceholder: 'Choose a new date',
      rescheduleErrorTitle: 'Rescheduling error',
      rescheduleError: 'The send date could not be updated.'
    },
    actions: {
      pay: 'Pay order',
      confirmPayment: 'Confirm payment',
      delete: 'Delete order',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    paymentMethod: {
      title: 'Payment method',
      card: 'Credit card',
      cardHint: 'Coming soon',
      transfer: 'Assigned bank transfer',
      transferHint: 'Bank transfer assigned to this order',
      acompte: 'Available deposit',
      acompteHint: 'Available balance: {amount}',
      acompteReservedHint: 'Including reserved for this order: {amount}'
    },
    pay: {
      confirmTitle: 'Pay order',
      confirmMessage: 'Confirm payment of {amount} for {count} beneficiary(ies)? Cards will be issued and the budget debited.',
      banner: 'This order has not been settled yet. Payment will issue the cards and debit the budget.',
      insufficientMessage: 'Your available deposit is insufficient. Would you like to cover the remaining {amount} with an assigned bank transfer?',
      emptyMessage: 'You have no funds available on the free deposit (balance €0). Please make a bank transfer to top up your free deposit.',
      completeByTransfer: 'Complete by bank transfer'
    },
    delete: {
      confirmTitle: 'Delete order',
      confirmMessage: 'Delete this order? This action cannot be undone.'
    },
    notifications: {
      deleted: 'Order deleted.',
      paid: 'Order paid. Cards have been issued.',
      loadErrorTitle: 'Loading error',
      loadError: 'Unable to load orders.',
      deleteErrorTitle: 'Delete error',
      deleteError: 'The order could not be deleted.',
      payErrorTitle: 'Payment error',
      payError: 'Payment failed. Check the budget or order status.',
      acompteDeleted: 'Deposit deleted.',
      acompteDeleteErrorTitle: 'Delete error',
      acompteDeleteError: 'The deposit could not be deleted.'
    }
  },
  newAcompte: {
    breadcrumb: {
      current: 'Make a deposit'
    },
    title: 'Make a deposit',
    subtitle: 'Declare a payment made or to be made. It will be validated by an administrator.',
    form: {
      amount: 'Amount',
      comment: 'Reason',
      assignedToOrder: 'This deposit will be assigned to order {reference}.',
      rules: {
        amount: 'Amount is required'
      }
    },
    actions: {
      cancel: 'Cancel',
      submit: 'Submit deposit'
    },
    notifications: {
      success: {
        title: 'Deposit recorded',
        subtitle: 'Free deposit order awaiting payment, please make your bank transfer with the following reference: {reference}',
        subtitleReserved: 'Reserved deposit order awaiting payment, please make your bank transfer with the following reference: {reference}'
      },
      error: {
        title: 'Error',
        subtitle: 'The deposit could not be recorded.'
      }
    }
  },
  cultureSubsidy: {
    title: 'Culture subsidy',
    subtitle: 'Partial coverage of culture purchases for your beneficiaries, from the free deposit.',
    demo: 'Demo data',
    resetDemo: 'Reset demo',
    resetDone: 'Demo data reset',
    breadcrumb: {
      dashboard: 'Dashboard',
      current: 'Culture subsidy'
    },
    status: {
      active: 'Active',
      disabled: 'Disabled',
      blocked: 'Blocked'
    },
    nav: {
      overview: 'Overview',
      settings: 'Rules',
      funding: 'Reserve',
      history: 'History',
      products: 'Products',
      operations: 'Operations',
      beneficiaries: 'Beneficiaries'
    },
    gauge: {
      consumed: 'Consumed',
      reserve: 'Available reserve',
      fallback: 'Theoretical fallback',
      budget: 'Configured budget',
      aria: 'Subsidy gauge. Consumed {consumed} €, reserve {reserve} €, fallback {fallback} €, budget {budget} €'
    },
    pockets: {
      culture_reserve: 'Culture reserve',
      loyalty: 'Loyalty',
      free: 'Free deposit',
      recycling: 'Recycling'
    },
    movements: {
      feed_wire: 'Direct wire',
      feed_from_free: 'Transfer from free deposit',
      feed_from_loyalty: 'Transfer from loyalty',
      feed_from_recycling: 'Transfer from recycling',
      empty_to_free: 'Empty to free deposit',
      debit_cashback: 'Purchase debit',
      cancel_cashback: 'Purchase cancellation'
    },
    rules: {
      special_product: 'Product operation',
      special_global: 'Global operation',
      product_value: 'Product value',
      standard_rate: 'Standard rate'
    },
    conflicts: {
      twoGlobals: 'Two global special operations overlap. This overlap is forbidden.',
      sameProduct: 'Two special operations overlap on the same product. This overlap is forbidden.',
      globalAndProduct: 'A global operation coexists with a product operation. The most specific rule wins. This is not blocking.'
    },
    overview: {
      blockedTitle: 'Subsidy blocked',
      blockedFallback: 'The subsidy cannot apply until the reserve is funded again.',
      gaugeTitle: 'Reserve gauge',
      gaugeSubtitle: 'Consumed, reserve, just-in-time fallback and configured budget.',
      fundCta: 'Fund',
      nextAction: 'Next action',
      activeOps: 'Active operations',
      caps: 'Caps nearby',
      capsHint: 'Have used 80% or more of their envelope',
      noOps: 'No active special operation',
      runningOps: 'Active special operations',
      recent: 'Latest movements',
      seeAll: 'See history',
      howTitle: 'How it works',
      how1: 'You set the rate, caps and fallback order.',
      how2: 'You fund the culture reserve from the free deposit, loyalty, recycling or a wire transfer.',
      how3: 'On an eligible purchase, the subsidy is reserved for 15 minutes then debited on confirmation.',
      recoDisabledTitle: 'Enable the subsidy',
      recoDisabledText: 'The subsidy is disabled. Beneficiaries cannot see the benefit.',
      recoEmptyTitle: 'Fund the reserve',
      recoEmptyText: 'The reserve is empty. Purchases will only use fallback if it is enabled.',
      recoLowTitle: 'Top up the reserve',
      recoLowText: 'Less than 15% of the budget remains in reserve.',
      recoCapTitle: 'Watch annual caps',
      recoCapText: 'Several beneficiaries are close to their annual cap.',
      recoOkTitle: 'Nothing urgent',
      recoOkText: 'The subsidy is running. Check history for movement details.'
    },
    settings: {
      rateTitle: 'Standard subsidy rate',
      rateHint: 'A single default rate, applied to every eligible product without a more specific rule.',
      orderCapTitle: 'Cap per order',
      orderCapHint: 'The subsidy on an order never exceeds this ceiling.',
      valueModeTitle: 'Per-product value',
      valueModeHint: 'When enabled, some products can carry a euro value instead of the rate. A single generic value for all products is not allowed.',
      valueModeOn: 'Value mode on',
      annualCapTitle: 'Annual cap per beneficiary',
      annualCapHint: 'Ceiling on the calendar year. Beyond it, the subsidy is applied pro rata of the remaining amount.',
      budgetTitle: 'Configured budget',
      budgetHint: 'Reference envelope shown on the gauge. This is not a funds transfer.',
      fallbackTitle: 'Multi-pocket fallback',
      fallbackHint: 'No transfer is made in advance. At purchase time, if the reserve is not enough, enabled pockets take over in this order.',
      fallbackReserve: 'Always used first, limited to its balance.',
      fallbackLoyalty: 'Used first when the reserve is not enough.',
      fallbackFree: 'Used after loyalty, or instead of it if loyalty is off.',
      fallbackRecycling: 'Last resort only.',
      always: 'Always',
      statusTitle: 'Activation',
      statusHint: 'A disabled subsidy no longer appears to beneficiaries. Blocking is reserved for exhaustion cases.',
      cancel: 'Cancel',
      save: 'Save rules',
      saved: 'Rules saved'
    },
    simulator: {
      title: 'Simulate a purchase',
      subtitle: 'The engine applies this hierarchy: product operation, global operation, product value, then standard rate.',
      product: 'Product',
      beneficiary: 'Beneficiary',
      newBeneficiary: 'Beneficiary with no usage',
      amount: 'Order amount',
      run: 'Compute subsidy',
      remaining: 'Left to pay',
      subsidy: 'Subsidy',
      unsaved: 'Save the rules so the simulator can use them.'
    },
    funding: {
      emptyCta: 'Empty to free deposit',
      sourcesTitle: 'Fund the reserve',
      justInTimeTitle: 'Just-in-time fallback',
      justInTimeText: 'Enabling a fallback pocket does not move funds. It is only debited at purchase time if the culture reserve is not enough.',
      wireTitle: 'Direct wire',
      wireHint: 'Use this dedicated reference so the wire funds the culture reserve, not the free deposit.',
      wireCard: 'New funds, with a dedicated reference.',
      freeCard: 'Move part of the free deposit into the reserve.',
      loyaltyCard: 'Debit loyalty, credit the reserve immediately.',
      recyclingCard: 'Same from the recycling account.',
      copy: 'Copy',
      copied: 'Reference copied',
      amount: 'Amount',
      comment: 'Comment',
      wireSubmit: 'Record the wire',
      transferHint: 'Available maximum: {max}',
      transferFrom: 'Transfer from {pocket}',
      transferSubmit: 'Transfer to reserve',
      success: 'Reserve funded',
      emptyTitle: 'Empty the reserve',
      emptyHint: 'Funds go back to the free deposit, with no fee.',
      emptySubmit: 'Empty',
      emptySuccess: 'Reserve emptied to the free deposit'
    },
    history: {
      search: 'Search (beneficiary, order…)',
      type: 'Movement type',
      export: 'Export CSV',
      empty: 'No movements'
    },
    products: {
      readonlyTitle: 'Read-only catalog',
      readonlyText: 'Eligibility and per-product values are managed by Walleo. Here you see the rate actually applied from your rules.',
      search: 'Search a product',
      brand: 'Brand',
      eligibility: 'Eligibility',
      all: 'All',
      eligibleOnly: 'Eligible',
      notEligible: 'Not eligible',
      product: 'Product',
      price: 'CSE price',
      eligible: 'Eligible',
      yes: 'Yes',
      no: 'No',
      value: 'Product value',
      applied: 'Applied rule'
    },
    operations: {
      readonlyTitle: 'Read-only special operations',
      readonlyText: 'Creating special operations is reserved to Walleo in this version.',
      warningTitle: 'Configuration to watch',
      timelineTitle: 'Calendar {year}',
      create: 'Create an operation',
      name: 'Name',
      type: 'Type',
      global: 'Global',
      perProduct: 'Per product',
      target: 'Target',
      allCulture: 'Whole culture category',
      window: 'Window',
      boost: 'Rate / value',
      delete: 'Delete',
      product: 'Product',
      boostMode: 'Boost type',
      rate: 'Boosted rate',
      value: 'Boosted value',
      save: 'Create',
      created: 'Operation created',
      incomplete: 'Please fill in the name and date window.',
      deleteConfirm: 'Delete this special operation?'
    },
    beneficiaries: {
      search: 'Search a beneficiary',
      all: 'All',
      near: 'Close to the cap',
      atCap: 'Cap reached',
      name: 'Beneficiary',
      consumed: 'Annual usage',
      remaining: 'Remaining',
      lastPurchase: 'Last purchase'
    },
    admin: {
      title: 'Culture subsidy supervision',
      subtitle: 'Caretaker monitoring, alerts, and eligible product catalog.',
      breadcrumb: 'Culture supervision',
      nav: {
        supervision: 'Supervision',
        alerts: 'Alerts',
        catalog: 'Catalog'
      },
      caretaker: 'Caretaker',
      status: 'Status',
      caps: 'Caps',
      kpiActive: 'Active',
      kpiBlocked: 'Blocked',
      kpiReserve: 'Total reserve',
      kpiAlerts: 'Alerts',
      detailHint: 'Click a row to manage special operations for this caretaker.',
      severity: {
        critical: 'Critical',
        watch: 'Watch',
        info: 'Info'
      },
      noAlerts: 'No alert in this category'
    }
  },
  developerMode: {
    enabledTitle: 'Developer mode enabled',
    enabledMessage: 'Mock features are now visible.',
    disabledTitle: 'Developer mode disabled',
    disabledMessage: 'Mock features have been hidden.'
  }
}
